import React from "react";

function WorkspaceCard({ workspace, onOpen, actions }) {
   const handleKeyDown = (event) => {
      if (event.key === "Enter" || event.key === " ") {
         event.preventDefault();
         onOpen();
      }
   };

   return (
      <div
         className="workspace-card"
         role="button"
         tabIndex={0}
         aria-label={`Open ${workspace.name}`}
         onClick={onOpen}
         onKeyDown={handleKeyDown}
      >
         {actions && (
            <div
               className="workspace-card__actions"
               onClick={(event) => event.stopPropagation()}
               onKeyDown={(event) => event.stopPropagation()}
            >
               {actions}
            </div>
         )}

         <span className="workspace-card__mark">
            <svg
               width="26"
               height="26"
               viewBox="0 0 35 35"
               fill="none"
               stroke="currentColor"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
               aria-hidden="true"
            >
               <path d="M18.5109 32.8695L32.8699 18.5104C33.5909 17.7895 33.5909 16.6206 32.8699 15.8997L18.5107 1.54052C17.7898 0.819575 16.6209 0.81957 15.9 1.54051L1.54092 15.8996C0.819988 16.6205 0.819993 17.7894 1.54093 18.5103L15.9001 32.8695C16.6211 33.5904 17.7899 33.5904 18.5109 32.8695Z" />
               <path d="M8.06763 25.0374L7.41488 10.0255" />
               <path d="M25.0377 8.06681L10.0259 7.41406" />
               <path d="M9.37354 26.3438L24.3853 26.9965" />
               <path d="M26.3436 9.3732L26.9963 24.385" />
            </svg>
         </span>

         <div className="workspace-card__body">
            <p className="workspace-card__name" title={workspace.name}>
               {workspace.name}
            </p>
            <p className="workspace-card__description">
               {workspace.description?.trim() || "No description added yet"}
            </p>
         </div>
      </div>
   );
}

export default WorkspaceCard;
